export const ANIMATIC_ON = 'on';
export const ANIMATIC_OFF = 'off';
export const ANIMATIC_FAULTED = 'faulted';
export const ANIMATIC_ESTOPPED = 'disabled';

export const ANIMATIC_PRIMARY_LABEL = 'primary';
export const ANIMATIC_SECONDARY_LABEL = 'secondary';

export const ANIMATIC_CRITICAL_VARIANT = 'critical';
export const ANIMATIC_DEFAULT_VARIANT = 'default';
